import { render, staticRenderFns } from "./DataBlockStats.vue?vue&type=template&id=1c5bc588&scoped=true&lang=pug&"
import script from "./DataBlockStats.vue?vue&type=script&lang=js&"
export * from "./DataBlockStats.vue?vue&type=script&lang=js&"
import style0 from "./DataBlockStats.vue?vue&type=style&index=0&id=1c5bc588&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5bc588",
  null
  
)

export default component.exports